export enum ParamsPath {
  COUNTRY = 'country',
  COUNTRY_FMA = 'countryFMA',
  SOURCE = 'source',
  CAT = 'cat',
  AUTH_TOKEN = 'authToken',
  GERONIMO_COUNTRY = 'geronimoCountry',
  GERONIMO_DEALER_ID = 'geronimoDealerId',
  UNAUTHORIZED_ERROR_CODE = '401',
  INVALID_COUNTRY_TYPE_ERROR = 'invalid-country',
  INTERCEPT_DEALER = 'intercept-dealer'
}
